var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcn15(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e23038;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.35,52.42h-2v-27H61a1.62,1.62,0,0,0,.81-3L36.61,7.83a3.25,3.25,0,0,0-3.22,0L8.22,22.34a1.62,1.62,0,0,0,.81,3H12.6V52.42H10.65A3.26,3.26,0,0,0,7.4,55.67v3.68a3.25,3.25,0,0,0,3.25,3.24h48.7a3.25,3.25,0,0,0,3.25-3.24V55.67A3.26,3.26,0,0,0,59.35,52.42ZM35,10.65,54.9,22.12H15.1ZM54.15,48.74v3.68H15.85V48.74ZM15.85,45.5V25.37h3.67V45.5Zm6.92,0V25.37h7.14V45.5Zm10.39,0V25.37h3.68V45.5Zm6.93,0V25.37h7.14V45.5Zm10.39,0V25.37h3.67V45.5Zm8.87,13.85H10.65V55.67h48.7C59.35,59.43,59.36,59.35,59.35,59.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 70,
    height: 70
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn15);
export default __webpack_public_path__ + "static/media/icn_15.4d98bb5fb9b4410be818340bed8f56f3.svg";
export { ForwardRef as ReactComponent };